export var mockAutomatedCampaigns = [
    {
        id: '1',
        name: 'Intelligent reminders',
        description: "Sent 1 week before a client's typical appointment.",
        audience: ['Dynamic', 'AI optimized'],
        totalAudienceCount: 0,
        openRate: 0.0,
        userCount: 0,
        totalSalesAmount: 0,
        saleCount: 0,
        frequency: 'AI optimized',
        isRecurring: true,
        isEnabled: true,
        ownerId: '',
        ownerType: 'brand',
        type: 'recurring',
        subject: '',
        body: '',
        title: '',
        smsBody: '',
        pushBody: '',
        status: 'completed',
        color: '',
        price: 0,
        emailOpenRateCounter: 0,
        smsOpenRateCounter: 0,
        pushOpenRateCounter: 0,
        totalUniqueOpenRateCounter: 0,
        numberOfSales: 0,
        customersNotifiedViaEmail: 0,
        customersNotifiedViaSms: 0,
        customersNotifiedViaPush: 0,
        totalCustomersNotified: 0,
        customerGroups: [],
        sendEmail: false,
        sendSms: false,
        sendPush: false,
        overrideDefaultNotificationsConsent: false,
        fallbackToDefaultEmailConsent: false,
        revenue: 0,
        scheduledAt: '',
        completedAt: '',
        recurringSendToAllCustomers: false,
        createdAt: '',
        updatedAt: '',
        deletedAt: '',
        logoId: '',
        backgroundId: '',
        promoId: '',
        logo: undefined,
        background: undefined,
        promo: {
            code: '',
            createdAt: '',
            deletedAt: '',
            id: '',
            isBrandPromo: false,
            isRewardPromo: false,
            isSquirePromo: false,
            kind: 0,
            redeemCount: 0,
            rules: [],
            shops: [],
            totalRedeemedAmount: 0,
            updatedAt: '',
            value: 0,
        },
        recurring: false,
        displayName: '',
        allowedActions: [],
        updatedBy: {
            kind: 0,
            userId: '',
            username: '',
            thumbnail: '',
            timestamp: '',
            firstName: '',
            lastName: '',
        },
    },
    {
        id: '2',
        name: 'Last-minute availability',
        description: 'Sent to clients when a spot opens from a cancellation.',
        audience: ['Regulars', 'Prospective'],
        totalAudienceCount: 7108,
        openRate: 21.89,
        userCount: 2012,
        totalSalesAmount: 57490,
        saleCount: 39,
        frequency: 'Weekly',
        isRecurring: true,
        isEnabled: true,
        conversionRate: 35.2,
        sentCampaigns: 39,
        sinceDate: 'Mar 20, 2025',
        ownerId: '',
        ownerType: 'brand',
        type: 'recurring',
        subject: '',
        body: '',
        title: '',
        smsBody: '',
        pushBody: '',
        status: 'completed',
        color: '',
        price: 0,
        emailOpenRateCounter: 0,
        smsOpenRateCounter: 0,
        pushOpenRateCounter: 0,
        totalUniqueOpenRateCounter: 0,
        numberOfSales: 0,
        customersNotifiedViaEmail: 0,
        customersNotifiedViaSms: 0,
        customersNotifiedViaPush: 0,
        totalCustomersNotified: 0,
        customerGroups: [],
        sendEmail: false,
        sendSms: false,
        sendPush: false,
        overrideDefaultNotificationsConsent: false,
        fallbackToDefaultEmailConsent: false,
        revenue: 0,
        scheduledAt: '',
        completedAt: '',
        recurringSendToAllCustomers: false,
        createdAt: '',
        updatedAt: '',
        deletedAt: '',
        logoId: '',
        backgroundId: '',
        promoId: '',
        logo: undefined,
        background: undefined,
        promo: {
            code: '',
            createdAt: '',
            deletedAt: '',
            id: '',
            isBrandPromo: false,
            isRewardPromo: false,
            isSquirePromo: false,
            kind: 0,
            redeemCount: 0,
            rules: [],
            shops: [],
            totalRedeemedAmount: 0,
            updatedAt: '',
            value: 0,
        },
        recurring: false,
        displayName: '',
        allowedActions: [],
        updatedBy: {
            kind: 0,
            userId: '',
            username: '',
            thumbnail: '',
            timestamp: '',
            firstName: '',
            lastName: '',
        },
    },
    {
        id: '3',
        name: 'Reactivate lapsed clients',
        description: 'Sent to clients inactive for 6-12 weeks or longer.',
        audience: ['Dynamic'],
        totalAudienceCount: 813,
        openRate: 0.0,
        userCount: 0,
        totalSalesAmount: 0,
        saleCount: 0,
        frequency: 'Monthly',
        isRecurring: true,
        isEnabled: false,
        ownerId: '',
        ownerType: 'brand',
        type: 'recurring',
        subject: '',
        body: '',
        title: '',
        smsBody: '',
        pushBody: '',
        status: 'completed',
        color: '',
        price: 0,
        emailOpenRateCounter: 0,
        smsOpenRateCounter: 0,
        pushOpenRateCounter: 0,
        totalUniqueOpenRateCounter: 0,
        numberOfSales: 0,
        customersNotifiedViaEmail: 0,
        customersNotifiedViaSms: 0,
        customersNotifiedViaPush: 0,
        totalCustomersNotified: 0,
        customerGroups: [],
        sendEmail: false,
        sendSms: false,
        sendPush: false,
        overrideDefaultNotificationsConsent: false,
        fallbackToDefaultEmailConsent: false,
        revenue: 0,
        scheduledAt: '',
        completedAt: '',
        recurringSendToAllCustomers: false,
        createdAt: '',
        updatedAt: '',
        deletedAt: '',
        logoId: '',
        backgroundId: '',
        promoId: '',
        logo: undefined,
        background: undefined,
        promo: {
            code: '',
            createdAt: '',
            deletedAt: '',
            id: '',
            isBrandPromo: false,
            isRewardPromo: false,
            isSquirePromo: false,
            kind: 0,
            redeemCount: 0,
            rules: [],
            shops: [],
            totalRedeemedAmount: 0,
            updatedAt: '',
            value: 0,
        },
        recurring: false,
        displayName: '',
        allowedActions: [],
        updatedBy: {
            kind: 0,
            userId: '',
            username: '',
            thumbnail: '',
            timestamp: '',
            firstName: '',
            lastName: '',
        },
    },
    {
        id: '4',
        name: 'Welcome prospects',
        description: "Sent to prospects who haven't booked an appointment yet.",
        audience: ['Prospective'],
        totalAudienceCount: 813,
        openRate: 0.0,
        userCount: 0,
        totalSalesAmount: 0,
        saleCount: 0,
        frequency: 'Adhoc',
        isRecurring: true,
        isEnabled: true,
        ownerId: '',
        ownerType: 'brand',
        type: 'recurring',
        subject: '',
        body: '',
        title: '',
        smsBody: '',
        pushBody: '',
        status: 'completed',
        color: '',
        price: 0,
        emailOpenRateCounter: 0,
        smsOpenRateCounter: 0,
        pushOpenRateCounter: 0,
        totalUniqueOpenRateCounter: 0,
        numberOfSales: 0,
        customersNotifiedViaEmail: 0,
        customersNotifiedViaSms: 0,
        customersNotifiedViaPush: 0,
        totalCustomersNotified: 0,
        customerGroups: [],
        sendEmail: false,
        sendSms: false,
        sendPush: false,
        overrideDefaultNotificationsConsent: false,
        fallbackToDefaultEmailConsent: false,
        revenue: 0,
        scheduledAt: '',
        completedAt: '',
        recurringSendToAllCustomers: false,
        createdAt: '',
        updatedAt: '',
        deletedAt: '',
        logoId: '',
        backgroundId: '',
        promoId: '',
        logo: undefined,
        background: undefined,
        promo: {
            code: '',
            createdAt: '',
            deletedAt: '',
            id: '',
            isBrandPromo: false,
            isRewardPromo: false,
            isSquirePromo: false,
            kind: 0,
            redeemCount: 0,
            rules: [],
            shops: [],
            totalRedeemedAmount: 0,
            updatedAt: '',
            value: 0,
        },
        recurring: false,
        displayName: '',
        allowedActions: [],
        updatedBy: {
            kind: 0,
            userId: '',
            username: '',
            thumbnail: '',
            timestamp: '',
            firstName: '',
            lastName: '',
        },
    },
    {
        id: '5',
        name: 'Thank first-time clients',
        description: "Sent after a client's first appointment.",
        audience: ['New Clients'],
        totalAudienceCount: 813,
        openRate: 0.0,
        userCount: 0,
        totalSalesAmount: 0,
        saleCount: 0,
        frequency: 'Weekly',
        isRecurring: true,
        isEnabled: false,
        ownerId: '',
        ownerType: 'brand',
        type: 'recurring',
        subject: '',
        body: '',
        title: '',
        smsBody: '',
        pushBody: '',
        status: 'completed',
        color: '',
        price: 0,
        emailOpenRateCounter: 0,
        smsOpenRateCounter: 0,
        pushOpenRateCounter: 0,
        totalUniqueOpenRateCounter: 0,
        numberOfSales: 0,
        customersNotifiedViaEmail: 0,
        customersNotifiedViaSms: 0,
        customersNotifiedViaPush: 0,
        totalCustomersNotified: 0,
        customerGroups: [],
        sendEmail: false,
        sendSms: false,
        sendPush: false,
        overrideDefaultNotificationsConsent: false,
        fallbackToDefaultEmailConsent: false,
        revenue: 0,
        scheduledAt: '',
        completedAt: '',
        recurringSendToAllCustomers: false,
        createdAt: '',
        updatedAt: '',
        deletedAt: '',
        logoId: '',
        backgroundId: '',
        promoId: '',
        logo: undefined,
        background: undefined,
        promo: {
            code: '',
            createdAt: '',
            deletedAt: '',
            id: '',
            isBrandPromo: false,
            isRewardPromo: false,
            isSquirePromo: false,
            kind: 0,
            redeemCount: 0,
            rules: [],
            shops: [],
            totalRedeemedAmount: 0,
            updatedAt: '',
            value: 0,
        },
        recurring: false,
        displayName: '',
        allowedActions: [],
        updatedBy: {
            kind: 0,
            userId: '',
            username: '',
            thumbnail: '',
            timestamp: '',
            firstName: '',
            lastName: '',
        },
    },
    {
        id: '6',
        name: 'Birthday Message',
        description: 'Sent to clients on their birthday.',
        audience: ['Weekly Birthdays'],
        totalAudienceCount: 813,
        openRate: 0.0,
        userCount: 0,
        totalSalesAmount: 0,
        saleCount: 0,
        frequency: 'Weekly',
        isRecurring: true,
        isEnabled: true,
        ownerId: '',
        ownerType: 'brand',
        type: 'recurring',
        subject: '',
        body: '',
        title: '',
        smsBody: '',
        pushBody: '',
        status: 'completed',
        color: '',
        price: 0,
        emailOpenRateCounter: 0,
        smsOpenRateCounter: 0,
        pushOpenRateCounter: 0,
        totalUniqueOpenRateCounter: 0,
        numberOfSales: 0,
        customersNotifiedViaEmail: 0,
        customersNotifiedViaSms: 0,
        customersNotifiedViaPush: 0,
        totalCustomersNotified: 0,
        customerGroups: [],
        sendEmail: false,
        sendSms: false,
        sendPush: false,
        overrideDefaultNotificationsConsent: false,
        fallbackToDefaultEmailConsent: false,
        revenue: 0,
        scheduledAt: '',
        completedAt: '',
        recurringSendToAllCustomers: false,
        createdAt: '',
        updatedAt: '',
        deletedAt: '',
        logoId: '',
        backgroundId: '',
        promoId: '',
        logo: undefined,
        background: undefined,
        promo: {
            code: '',
            createdAt: '',
            deletedAt: '',
            id: '',
            isBrandPromo: false,
            isRewardPromo: false,
            isSquirePromo: false,
            kind: 0,
            redeemCount: 0,
            rules: [],
            shops: [],
            totalRedeemedAmount: 0,
            updatedAt: '',
            value: 0,
        },
        recurring: false,
        displayName: '',
        allowedActions: [],
        updatedBy: {
            kind: 0,
            userId: '',
            username: '',
            thumbnail: '',
            timestamp: '',
            firstName: '',
            lastName: '',
        },
    },
    {
        id: '7',
        name: 'Holiday Message',
        description: 'Sent to clients during holidays or special events.',
        audience: ['All Clients'],
        totalAudienceCount: 813,
        openRate: 0.0,
        userCount: 0,
        totalSalesAmount: 0,
        saleCount: 0,
        frequency: 'Weekly',
        isRecurring: true,
        isEnabled: false,
        ownerId: '',
        ownerType: 'brand',
        type: 'recurring',
        subject: '',
        body: '',
        title: '',
        smsBody: '',
        pushBody: '',
        status: 'completed',
        color: '',
        price: 0,
        emailOpenRateCounter: 0,
        smsOpenRateCounter: 0,
        pushOpenRateCounter: 0,
        totalUniqueOpenRateCounter: 0,
        numberOfSales: 0,
        customersNotifiedViaEmail: 0,
        customersNotifiedViaSms: 0,
        customersNotifiedViaPush: 0,
        totalCustomersNotified: 0,
        customerGroups: [],
        sendEmail: false,
        sendSms: false,
        sendPush: false,
        overrideDefaultNotificationsConsent: false,
        fallbackToDefaultEmailConsent: false,
        revenue: 0,
        scheduledAt: '',
        completedAt: '',
        recurringSendToAllCustomers: false,
        createdAt: '',
        updatedAt: '',
        deletedAt: '',
        logoId: '',
        backgroundId: '',
        promoId: '',
        logo: undefined,
        background: undefined,
        promo: {
            code: '',
            createdAt: '',
            deletedAt: '',
            id: '',
            isBrandPromo: false,
            isRewardPromo: false,
            isSquirePromo: false,
            kind: 0,
            redeemCount: 0,
            rules: [],
            shops: [],
            totalRedeemedAmount: 0,
            updatedAt: '',
            value: 0,
        },
        recurring: false,
        displayName: '',
        allowedActions: [],
        updatedBy: {
            kind: 0,
            userId: '',
            username: '',
            thumbnail: '',
            timestamp: '',
            firstName: '',
            lastName: '',
        },
    },
];
